<template>
  <InfoBlock
    v-if="detail.hasInfo"
    class="account-prize-api-card__info-block"
    trigger-label="i"
    aria-label="Информация о призе"
    :hover-mode="hoverMode"
  >
    <div class="demo-prize-popup-card account-prize-api-card__info-drop">
      <div v-if="detail.image" class="demo-prize-popup-card__image"></div>

      <h3 v-if="detail.title" class="demo-prize-popup-card__title">{{ detail.title }}</h3>

      <p
        v-if="detail.description"
        class="demo-prize-popup-card__text"
        v-html="formatRichText(detail.description)"
      ></p>

      <template v-if="detail.popupMode === 'physical' && detail.type !== 'grand'">
        <button
          v-if="detail.trackNumber"
          type="button"
          class="demo-prize-popup-card__copy"
          @click.stop="$emit('copy', detail.trackNumber)"
        >
          <span>{{ copiedCode === detail.trackNumber ? 'ТРЕК-НОМЕР СКОПИРОВАН' : detail.trackNumber }}</span>
          <span :class="['demo-prize-popup-card__copy-icon', { 'is-copied': copiedCode === detail.trackNumber }]"></span>
        </button>
        <p v-else class="demo-prize-popup-card__notice">Трек-номер для отслеживания посылки появится здесь после отправки заказа.</p>
      </template>

      <template v-else-if="detail.popupMode === 'promo_code'">
        <button
          v-if="detail.promoCode"
          type="button"
          class="demo-prize-popup-card__copy"
          @click.stop="$emit('copy', detail.promoCode)"
        >
          <span>{{ copiedCode === detail.promoCode ? 'ПРОМОКОД СКОПИРОВАН' : detail.promoCode }}</span>
          <span :class="['demo-prize-popup-card__copy-icon', { 'is-copied': copiedCode === detail.promoCode }]"></span>
        </button>
        <p v-else class="demo-prize-popup-card__notice">Промокод появится позднее, следите за обновлениями</p>
      </template>

      <template v-else-if="detail.popupMode === 'certificate'">
        <a
          v-if="detail.certificateLink"
          :href="detail.certificateLink"
          target="_blank"
          rel="noopener noreferrer"
          class="demo-prize-popup-card__link"
          @click.stop
        >
          Добавить
        </a>
        <button
          v-else-if="detail.certificateId != null"
          type="button"
          class="demo-prize-popup-card__action"
          @click.stop="$emit('download-cert', detail.certificateId)"
        >
          Скачать
        </button>
        <p v-else class="demo-prize-popup-card__notice">Сертификат появится позднее, следите за обновлениями</p>
      </template>

      <template v-else-if="detail.isStickerPack">
        <a
          :href="detail.cardLink"
          target="_blank"
          rel="noopener noreferrer"
          class="demo-prize-popup-card__link"
          @click.stop
        >
          Добавить
        </a>
      </template>
    </div>
  </InfoBlock>
</template>

<script>
import InfoBlock from '@/components/infoBlock.vue';

export default {
  name: 'AccountPrizeInfoBlock',
  components: {
    InfoBlock,
  },
  props: {
    detail: {
      type: Object,
      required: true,
    },
    hoverMode: {
      type: Boolean,
      default: false,
    },
    copiedCode: {
      type: String,
      default: '',
    },
    formatRichText: {
      type: Function,
      required: true,
    },
  },
  emits: ['copy', 'download-cert'],
};
</script>
